"use client";

import React from "react";
import { PageLayout, Text } from "@hubble/web";
import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import {
  ConverterPageContainer,
  ConverterPageContainerInner,
  OtherCardsContainer,
  OtherCardsContentContainer
} from "./styles";
import PriceConverterForm from "./PriceConverterForm";
import CoinMetricsCard from "./CoinMetricsCard";
import CoinPostsCard from "./CoinPostsCard";
import HowToBuyRedirectCard from "./AdCards/HowToBuyRedirectCard";
import AvailibilityRedirectCard from "./AdCards/AvailibilityRedirectCard";

const Converter = () => {
  const t = useTranslations(FILES.CONVERTER);
  return (
    <ConverterPageContainer>
      <ConverterPageContainerInner>
        <PageLayout>
          <PageLayout.Content>
            <Text.Heading size="xs" marketing>
              {t("pageHeading")}
            </Text.Heading>
            <PriceConverterForm />
            {/* Other Cards Section */}
            <OtherCardsContainer>
              <OtherCardsContentContainer>
                <CoinMetricsCard />
                <CoinPostsCard />
                <HowToBuyRedirectCard />
                <AvailibilityRedirectCard />
              </OtherCardsContentContainer>
            </OtherCardsContainer>
          </PageLayout.Content>
        </PageLayout>
      </ConverterPageContainerInner>
    </ConverterPageContainer>
  );
};

export default Converter;
